<script>
	import Basket from '../../Stores/Basket';
	import Product from '../../Stores/Product';

	let active = Basket.isIndex();

	Basket.subscribe(data => {
		active = Basket.isIndex();
	});
</script>

<style>
	div.zes-notice {
		font-size: .9em;
		color: var(--zes-1-1);
		padding: 1em;
		margin-bottom: 1em;
		border-radius: .5em;
		background: var(--zes-1-4);
	}

	div.zes-notice span {
		font-weight: 700;
		text-decoration: underline;
		color: var(--zes-1-2);
		cursor: pointer;
	}

	div.zes-notice span:hover {
		text-decoration: none;
	}

	div.zes-notice i {
		color: var(--zes-1-2);
		margin-right: .5em;
	}
</style>

{#if active}
	<div class="zes-notice">
		<i class="fa-duotone fa-cart-shopping"></i> Je bewerkt een <b>{$Product.name}</b> uit het winkelmandje. Je kunt deze configuratie ook als een <span on:click="{event => Basket.setClear()}">nieuw artikel aanmaken</span>.
	</div>
{/if}